// EXPERIMENT #171270395

import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import GoogleSignupCta from 'components/signup_modal/google_signup_cta';
import LeadFormWithPassword from './lead_form_with_password';
import CompanyLeadShape from '../constants/CompanyLeadShape';
import { Footer } from './signup_form';
import { getAnswersFromStorage } from '../storage_helpers';

const Header = () => (
  <h1 className="h4 margin-bottom-none">
    Based on your response, Gusto could be a great fit for your business.
  </h1>
);

const Divider = () => (
  <div className="padding-bottom-10px padding-top-10px">
    <div className="google-signup-or text-center overflow-hidden">
      <span>or</span>
    </div>
  </div>
);

const HomepageSignupForm = ({ fromGoogleSSO, companyLead }) => {
  const getContractorOnly = () => {
    const surveyAnswers = getAnswersFromStorage();
    return surveyAnswers.WORKERS_TYPE === 'contractor_only';
  };

  return (
    <span>
      <Header />
      <div className="padding-top-10px width-100">
        {!fromGoogleSSO && (
          <div>
            <GoogleSignupCta
              googleSignupBaseUrl="/google_sso/homepage_survey_signup/new"
              googleButtonLabel="Sign up with Google"
            />
            <Divider />
          </div>
        )}
        <LeadFormWithPassword
          contractorOnly={getContractorOnly()}
          companyLead={companyLead}
          fromGoogleSSO={fromGoogleSSO}
          formExpandable
        />
        <div className="margin-top-25px text-center">
          <Footer />
        </div>
      </div>
    </span>
  );
};

HomepageSignupForm.propTypes = {
  fromGoogleSSO: PropTypes.bool.isRequired,
  companyLead: CompanyLeadShape.isRequired,
};

export default hot(module)(HomepageSignupForm);
